<template>
  <div class="shell-loading">
    <div class="spinner" aria-hidden="true"></div>
    <h2>Loading</h2>
    <p>Preparing workspace...</p>
  </div>
</template>

<script>
export default {
  name: 'shell-loading'
};
</script>

<style scoped>
.shell-loading {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: #f3f4f6;
  color: #2f2f2f;
  gap: 0.5rem;
}

.spinner {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  border: 0.25rem solid #d7dbe0;
  border-top-color: #4a8dd8;
  animation: spin 900ms linear infinite;
}

h2 {
  margin: 0.3rem 0 0;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.08rem;
}

p {
  margin: 0;
  font-size: 0.9rem;
  color: #6b7280;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
